// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"table"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 7L21 7L21 21L3 21L3 7Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 3H3V7H21V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 21H9M3 21H21M3 21V7M9 21H15M9 21V14M15 21H21M15 21V14M21 21V7M21 7H15M21 7V3H3V7M21 7H3M15 7H9M15 7V14M9 7H3M9 7V14M3 14H9M9 14H15M15 14H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TableIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'table',
    ref,
    icon: element,
  },
));

TableIcon.displayName = 'TableIcon';

export default TableIcon;
